//  $('body').on('change', '.product-form__single-selector', function() {
//     $('.product-form__single-selector').find('option').show();
//     var changeSelect = $(this);
//     var valSelected = changeSelect.val();
//     console.log('valSelected =',valSelected);
//     $(".product-form__single-selector").each(function( index ) {
//         var valSelected = $(this).val();
//         $("#custom-selector option").each(function(index) {
//             var cusVals = $(this).attr('value');
//             var cusAvail = $(this).attr('avail');
//             var cusSplit = cusVals.split('/');
//             if((cusSplit[0].trim() == valSelected || cusSplit[1].trim() == valSelected || cusSplit[2].trim() == valSelected)){
//                  var cusAvail = $(this).attr('avail');
//                  if(cusAvail == 'false'){
//                      console.log('cusSplit =',cusSplit);
//                      if(cusSplit[0].trim() == valSelected){
//                          $('.product-form__single-selector option[value="'+cusSplit[1].trim()+'"]').hide();
//                          $('.product-form__single-selector option[value="'+cusSplit[2].trim()+'"]').hide();
//                      }else if(cusSplit[1].trim() == valSelected){
//                          $('.product-form__single-selector option[value="'+cusSplit[0].trim()+'"]').hide();
//                          $('.product-form__single-selector option[value="'+cusSplit[2].trim()+'"]').hide();
//                      }else if(cusSplit[2].trim() == valSelected){
//                          $('.product-form__single-selector option[value="'+cusSplit[0].trim()+'"]').hide();
//                          $('.product-form__single-selector option[value="'+cusSplit[1].trim()+'"]').hide();
//                      }
//                  }
//             }
//         }); 
//     });
//   });
// $('.product-form__single-selector').change();


$(document).on('click', function(event) {
    // Check if the click is outside of .block-swatch-list
    if (!$(event.target).closest('.block-swatch-list').length) {
        // Remove 'active' class from all .block-swatch-list elements
        $('.block-swatch-list').removeClass('active');
    }
});

$('body').on('click', '.block-swatch-list label, .block-swatch-list', function() {
    // Toggle 'active' class on the closest .block-swatch-list
    if($(this).hasClass('block-swatch-list')){
      var forData = $(this).attr('for');
    }else{
      var forData = $(this).closest('.block-swatch-list').attr('for');
    }
    if($('.block-swatch-list.active').attr('for') != forData){
      $('.block-swatch-list.active').removeClass('active');
    }
    if($(this).hasClass('block-swatch-list')){
      $(this).toggleClass('active');
    }else{
      $(this).closest('.block-swatch-list').toggleClass('active');
    }
});
